<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="pa-2">
					<v-data-table
						hide-default-footer
						:headers="headers"
						:items="connectionTypes"
						class="elevation-1"
						:loading="loading"
					>
						<template #top>
							<v-toolbar flat>
								<v-toolbar-title class="px-4">جدول شبكات التواصل - الدورات التدريبية</v-toolbar-title>
								<v-divider insert vertical></v-divider>
								<v-spacer></v-spacer>
								<v-btn class="primary" @click="showAddNew = true">طريقة اتصال جديدة</v-btn>
							</v-toolbar>
						</template>

						<template #[`item.logo`]="{ item }">
							<v-avatar :size="24">
								<v-img contain :src="item.logo"></v-img>
							</v-avatar>
						</template>

						<template #[`item.initialProfilesPath`]="{ item }">
							<div dir="ltr" class="text-start">{{ item.initialProfilesPath }}</div>
						</template>

						<template #[`item.delete`]="{ item }">
							<v-tooltip bottom>
								<template #activator=" {on} ">
									<v-btn
										icon
										medium
										:disabled="loading"
										v-on="on"
										@click="deleteConnectionType(item.communicationTypeID)"
									>
										<v-icon color="error">mdi-comment-remove</v-icon>
									</v-btn>
								</template>
								<span>حذف</span>
							</v-tooltip>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="showAddNew" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة طريقة اتصال جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-select
									v-model="newConnType.communicationTypeID"
									:items="contactTypes"
									item-value="communicationTypeID"
									item-text="name"
									outlined
									label="المعرف"
									:rules="[rules.required]"
								></v-select>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-select
									v-model="newConnType.limited"
									:items="limits"
									outlined
									label="المجموعة"
									item-value="id"
									item-text="label"
									return-value
									:rules="[rules.required]"
								></v-select>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-alert type="info">المجمواعت 1-3 جميعها تشترك في الحد.</v-alert>
							</v-col>

							<v-col cols="12" class="text-center" @mouseover=";">
								<v-btn color="primary" :disabled="!valid" :loading="loading" @click="addNewConnType">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الدوات التدريبية', exact: true, to: { name: "dashboard-courses" } },
				{ text: 'شبكات التواصل', disabled: true }
			],
			connectionTypes: [],
			loading: true,
			headers: [
				{ value: "communicationTypeID", text: "المعرف" },
				{ value: "name", text: "نوع الاتصال" },
				{ value: "logo", text: "الايقونة" },
				{ value: "limitGroup", text: "المجموعة" },
				{ value: "initialProfilesPath", text: "البادئة" },
				{ value: "delete", text: "حذف", sortable: false }
			],
			showAddNew: false,
			newConnType: {
				communicationTypeID: null,
				limited: null
			},
			limits: [
				{ id: "0", label: "0 - غير محدود" },
				{ id: "1", label: "1 - نوع واحد من الاتصال" },
				{ id: "2", label: "2 - نوعين من الاتصال" },
				{ id: "3", label: "3 - ثلاث أنواع من الاتصال" }
			],
			valid: false,
			contactTypes: []
		};
	},
	mounted() {
		this.getConnectionTypes();
		this.getContactTypes();
	},
	methods: {
		getConnectionTypes() {
			client
				.get("/api/courses/conntype")
				.then(response => {
					this.loading = false;
					this.connectionTypes = response.data.map(c => {
						if (c.limitGroup == "0") {
							c.limitGroup = "غير محدود";
						} else if (c.limitGroup == "1") {
							c.limitGroup = "نوع واحد من الاتصال";
						} else if (c.limitGroup == "2") {
							c.limitGroup = "نوعين من الاتصال";
						} else if (c.limitGroup == "3") {
							c.limitGroup = "ثلاث أنواع من الاتصال";
						}
						return c;
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		deleteConnectionType(communicationTypeID) {
			this.loading = true;

			client
				.delete("/api/courses/deleteConnType/" + communicationTypeID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					this.connectionTypes = [];
					this.getConnectionTypes();
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getContactTypes() {
			client
				.get("/api/communication/types")
				.then(response => {
					this.contactTypes = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addNewConnType() {
			this.loading = true;
			var data = new FormData();
			data.append(
				"communicationTypeID",
				this.newConnType.communicationTypeID
			);
			data.append("limited", this.newConnType.limited);

			client
				.post("/api/courses/insertconntype", data)
				.then(response => {
					console.log(response);

					this.showAddNew = false;
					this.connectionTypes = [];
					this.getConnectionTypes();
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>